import React from 'react';
import { cn } from '../../utils/cn';

interface LoadingSkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}

export function LoadingSkeleton({ 
  className,
  variant = 'rectangular'
}: LoadingSkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse bg-gray-200",
        variant === 'circular' && 'rounded-full',
        variant === 'rectangular' && 'rounded',
        className
      )}
    />
  );
}

export function RateCardSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex justify-between items-start mb-4">
        <LoadingSkeleton className="h-6 w-24" />
        <LoadingSkeleton className="h-4 w-16" />
      </div>
      <div className="space-y-2">
        <LoadingSkeleton className="h-8 w-32 mx-auto" />
        <LoadingSkeleton className="h-4 w-20 mx-auto" />
      </div>
    </div>
  );
}